/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiDeviceNotifier } from './DeviceNotifier';

export interface DeviceRequest {

    id?: number;

    device_uuid?: string;

    os?: string;

    device_model?: string;

    browser_version?: string;

    native_notification_identifier?: string;

    device_notifiers?: ApiDeviceNotifier[];

}

@Model('Device')
export class ApiDevice extends BaseModel implements DeviceRequest {

    
    
    id: number;

    
    
    device_uuid: string;

    
    
    os: string;

    
    
    device_model: string;

    
    
    browser_version: string;

    
    
    native_notification_identifier: string;

    @Type('ApiDeviceNotifier')
    @Expand()
    device_notifiers: ApiDeviceNotifier[];

}
